import { API } from '../../API/api';
import { updateFilterOptionsAction } from '../../_flux/actions/filter_options_actions';
import { setLoadingCheckDoneAction, setOutOfStockAction } from '../../_flux/actions/vehicle_configurator_actions';

const REQUEST_CONFIG = {
    apiPath: '/api/v2/vehicle/make/',
    data: '',
    dataType: 'json'
};

export const onSuccess = response => {
    updateFilterOptionsAction(response);
};

export const onError = error => {
    setLoadingCheckDoneAction();
    setOutOfStockAction('generic-error-message');
    console.warn('Couldn\'t fetch vehicle configurator make');
};

export const getMake = () => API
    .GET(REQUEST_CONFIG)
    .then(onSuccess)
    .catch(onError);

export const loadVehicleConfiguratorMake = async function () {
    try {
        await getMake();
    } catch (error) {
        console.warn('Couldn\'t fetch vehicle configurator make: ', error);
    }
};